import React, { useState } from 'react';
import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import UserService from '../../services/UserService'; // Import UserService

const DoiMatKhauComponent = () => {
  const [matKhauCu, setMatKhauCu] = useState('');
  const [matKhauMoi, setMatKhauMoi] = useState('');
  const [xacNhanMatKhauMoi, setXacNhanMatKhauMoi] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Kiểm tra tính hợp lệ của mật khẩu
  const validatePasswords = () => {
    setErrorMessage(''); // Reset thông báo lỗi

    const hasUpperCase = /[A-Z]/.test(matKhauMoi);
    const hasLowerCase = /[a-z]/.test(matKhauMoi);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(matKhauMoi);
    const hasNumber = /[0-9]/.test(matKhauMoi);
    const isLongEnough = matKhauMoi.length >= 8;

    let errors = '';

    if (!isLongEnough) {
      errors += 'Mật khẩu phải có ít nhất 8 ký tự. ';
    }
    if (!hasUpperCase) {
      errors += 'Mật khẩu phải chứa ít nhất 1 chữ cái in hoa. ';
    }
    if (!hasLowerCase) {
      errors += 'Mật khẩu phải chứa ít nhất 1 chữ cái thường. ';
    }
    if (!hasSpecialChar) {
      errors += 'Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt. ';
    }
    if (!hasNumber) {
      errors += 'Mật khẩu phải chứa ít nhất 1 chữ số. ';
    }

    if (matKhauMoi !== xacNhanMatKhauMoi) {
      errors += 'Mật khẩu mới và xác nhận mật khẩu không khớp nhau. ';
    }

    if (errors) {
      setErrorMessage(errors);
      return false;
    }

    return true;
  };

  // Xử lý submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validatePasswords()) {
      try {
        // Gọi hàm đổi mật khẩu từ UserService
        const response = await UserService.doiMatKhau(matKhauCu, matKhauMoi, xacNhanMatKhauMoi);

        if (response.success) {
          setSuccessMessage('Mật khẩu đã được đổi thành công!');
          setErrorMessage('');
          // Reset form fields
          setMatKhauCu('');
          setMatKhauMoi('');
          setXacNhanMatKhauMoi('');
        } else {
          setErrorMessage(response.message);
          setSuccessMessage('');
        }
      } catch (error) {
        setErrorMessage('Có lỗi xảy ra. Vui lòng thử lại.');
        setSuccessMessage('');
      }
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={6}>
          <h2 className="text-center my-4">Đổi mật khẩu</h2>

          {/* Thông báo lỗi */}
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

          {/* Thông báo thành công */}
          {successMessage && <Alert variant="success">{successMessage}</Alert>}

          {/* Form đổi mật khẩu */}
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formMatKhauCu">
              <Form.Label>Mật khẩu cũ</Form.Label>
              <Form.Control
                type="password"
                placeholder="Nhập mật khẩu cũ"
                value={matKhauCu}
                onChange={(e) => setMatKhauCu(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formMatKhauMoi">
              <Form.Label>Mật khẩu mới</Form.Label>
              <Form.Control
                type="password"
                placeholder="Nhập mật khẩu mới"
                value={matKhauMoi}
                onChange={(e) => setMatKhauMoi(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formXacNhanMatKhauMoi">
              <Form.Label>Xác nhận mật khẩu mới</Form.Label>
              <Form.Control
                type="password"
                placeholder="Nhập lại mật khẩu mới"
                value={xacNhanMatKhauMoi}
                onChange={(e) => setXacNhanMatKhauMoi(e.target.value)}
                required
              />
            </Form.Group>

            <Button variant="danger" type="submit" className="w-100 mt-3">
              Xác nhận
            </Button>
          </Form>

          {/* Nút hủy */}
          <Button
            variant="secondary"
            className="w-100 mt-3"
            onClick={() => window.location.href = '/login'}
          >
            Hủy
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default DoiMatKhauComponent;
